export default __webpack_public_path__ + "static/media/ArdashirArena.4ae433d6.jpg";